// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2220Q","range":"MonthRangeSwitch_range__X1hsx","disabled":"MonthRangeSwitch_disabled__2xvNU"};